import React from 'react';
import { ChevronDown, ChevronUp, BookOpen, GraduationCap } from 'lucide-react';

const AdminFormationsTab = ({
  programs, courses, expandedProgram, setExpandedProgram
}) => {
  return (
          <div data-testid="admin-formations">
            <h2 className="heading-3" style={{ marginBottom: '1.5rem' }}>Mes Formations ({programs.length})</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {programs.map(prog => {
                const progCourses = courses.filter(c => c.programId === prog.id);
                const isExpanded = expandedProgram === prog.id;
                return (
                  <div key={prog.id} className="card" style={{ padding: 0, overflow: 'hidden' }} data-testid={`admin-formation-${prog.id}`}>
                    <div
                      onClick={() => setExpandedProgram(isExpanded ? null : prog.id)}
                      style={{
                        padding: '1.25rem 1.5rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '1rem',
                        background: isExpanded ? '#fce4ec' : 'var(--bg-card)', transition: 'background 0.2s'
                      }}
                    >
                      <div style={{
                        width: 48, height: 48, borderRadius: '12px',
                        background: 'linear-gradient(135deg, #E75480, #C2185B)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                      }}>
                        <GraduationCap size={24} style={{ color: 'white' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 700, fontSize: '1rem' }}>{prog.title}</div>
                        <div className="body-small" style={{ color: 'var(--text-muted)' }}>{prog.fullName}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <span style={{
                          background: '#e0f2fe', color: '#0369a1', padding: '0.3rem 0.75rem',
                          borderRadius: '1rem', fontSize: '0.75rem', fontWeight: 600
                        }}>
                          {progCourses.length} cours
                        </span>
                        {prog.price && (
                          <span style={{
                            background: '#dcfce7', color: '#166534', padding: '0.3rem 0.75rem',
                            borderRadius: '1rem', fontSize: '0.75rem', fontWeight: 600
                          }}>
                            {prog.hasThreeTierPricing ? `${prog.priceBronze}€ - ${prog.priceGold}€` : `${prog.price}€`}
                          </span>
                        )}
                        {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                      </div>
                    </div>
                    {isExpanded && (
                      <div style={{ borderTop: '1px solid var(--border-light)' }}>
                        {progCourses.length > 0 ? (
                          <div style={{ padding: '0.5rem 0' }}>
                            {progCourses.map((course, idx) => (
                              <div key={course.id} style={{
                                display: 'flex', alignItems: 'center', gap: '0.75rem',
                                padding: '0.75rem 1.5rem',
                                background: idx % 2 === 0 ? 'transparent' : 'var(--bg-section)',
                                borderBottom: idx < progCourses.length - 1 ? '1px solid var(--border-light)' : 'none'
                              }}>
                                <span style={{
                                  width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                                  background: course.id.includes('header') ? '#fef3c7' : '#f0f9ff',
                                  border: course.id.includes('header') ? '2px solid #f59e0b' : '1px solid #bae6fd',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: '0.65rem', fontWeight: 700,
                                  color: course.id.includes('header') ? '#92400e' : '#0369a1'
                                }}>
                                  {course.id.includes('header') ? 'B' : idx + 1}
                                </span>
                                <div style={{ flex: 1 }}>
                                  <span style={{
                                    fontSize: '0.85rem',
                                    fontWeight: course.id.includes('header') ? 700 : 400,
                                    color: course.id.includes('header') ? '#92400e' : 'var(--text-primary)'
                                  }}>
                                    {course.title}
                                  </span>
                                </div>
                                {course.slides && (
                                  <span className="caption" style={{ color: 'var(--text-muted)' }}>
                                    {course.slides} slides
                                  </span>
                                )}
                                {course.presentationType && (
                                  <span style={{
                                    padding: '0.15rem 0.5rem', borderRadius: '1rem',
                                    fontSize: '0.65rem', fontWeight: 600,
                                    background: '#f3e8ff', color: '#7c3aed'
                                  }}>
                                    {course.presentationType}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="body-small" style={{ padding: '1.5rem', color: 'var(--text-muted)', textAlign: 'center' }}>
                            Aucun cours rattaché à cette formation.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

  );
};

export default AdminFormationsTab;
